import axios from 'axios';
import {
    API_BASE_URL
} from "src/modules/3rd-party-management/constants";


export default class EntityRoutingService {
    static instance;

    static getInstance() {
        if (!EntityRoutingService.instance) {
            EntityRoutingService.instance = new EntityRoutingService();
        }
        return EntityRoutingService.instance;
    }

    async fetchRoutedEntitiesList(params = {}){
        const response = await axios.get(`${API_BASE_URL}/legal_entity/routing/list`, {
            params: params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data?.data;
    }

    async fetchUnRoutedEntitiesList(params = {}){
        const response = await axios.get(`${API_BASE_URL}/entity_management/legal/without-routing`, {
            params: params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data?.data;
    }

    async saveRouterSettings(id, payload){
        const response = await axios.post(`${API_BASE_URL}/legal_entity/${id}/edit_routing`, payload, {
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });

        return response
    }

    async fetchRoutingDetails(id){
        const response = await axios.get(`${API_BASE_URL}/legal_entity/${id}/routing`, {
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });
        return response.data
    }

    async restoreRouterSettings(id){
        const response = await axios.delete(`${API_BASE_URL}/legal_entity/${id}/clear_routing`, {
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });
        return response.data
    }
}
